module.exports = __webpack_public_path__ + "img/dropbox.0ab5e0ce.svg";